export default "__VITE_ASSET__C4Jv6dbs__"